export const fromPropsToMatchedSalonId = (props) => {
  const params = props?.match?.params ?? {};
  return params.salonId ?? params.id ?? null;
};

export const fromPropsToName = (props) => props?.match?.params?.name ?? '';

// TODO: add conversion to integer
export const fromPropsToClientId = (props) => props?.match?.params?.client_id ?? null;
